import React from 'react';
import { Spin } from 'antd';
import './Loading.scss';

export default function Loading (){
    return (
        <div className='spin-loading'>
            <Spin className='loading-spin' tip="Loading..." />
        </div>
    );
}